import { FormControl, FormGroup } from '@angular/forms';
import { Observable } from 'rxjs';
import { AbstractSubscribeUnsubscribeDirective } from '@cupoui/shared/components/abstract-subscribe-unsubscribe-directive';

export class Error {
  // eslint-disable-next-line @typescript-eslint/no-parameter-properties
  constructor(public readonly code: string, public readonly message: string) {}
}

export abstract class AbstractFormGroupComponent extends AbstractSubscribeUnsubscribeDirective {
  public fg: FormGroup;
  public running: boolean;
  public updated = false;
  public error: any;

  validateAllFormFields(formGroup: FormGroup): void {
    Object.keys(formGroup.controls).forEach(field => {
      const control = formGroup.get(field);
      if (control instanceof FormControl) {
        control.markAsTouched({ onlySelf: true });
      } else if (control instanceof FormGroup) {
        this.validateAllFormFields(control);
      }
    });
  }

  protected handleObservable<T = any>(observable: Observable<T>): void {
    this.running = true;
    const subscription = observable.subscribe(
      response => {
        this.stopped();
        this.updated = true;
        window.setTimeout(() => (this.updated = false), 2500);
        subscription.unsubscribe();
        this.onUpdated(response);
      },
      error => {
        // eslint-disable-next-line no-console
        console.error('error', error);
        this.stopped(error);
      }
    );
  }

  protected started(): void {
    this.error = null;
    this.running = true;
  }

  protected stopped(error?: any): void {
    this.running = false;
    this.error = error;
  }

  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  protected onUpdated(response: any): void {}
}
